/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { MouseEventHandler } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import doubleButtonStyle from "./doubleButtonStyle";
import { Link } from "react-router";

type DoubleButtonProps = {
  backClick?: MouseEventHandler;
  backLink: string;
  backText?: string;
  buttonClick?: MouseEventHandler;
  buttonLink: string | object;
  buttonText?: string;
  hideBackButton?: boolean;
};

const DoubleButton = ({
  backClick,
  backLink,
  backText = "zurück",
  buttonClick,
  buttonLink,
  buttonText = "weiter",
  hideBackButton = false,
}: DoubleButtonProps) => {
  const backButton = () => {
    return (
      !hideBackButton && (
        <Button sx={doubleButtonStyle.backButton} fullWidth variant={"text"} onClick={backClick} component={Link} to={backLink}>
          {backText}
        </Button>
      )
    );
  };

  return (
    <Grid
      container
      sx={[{
        justifyContent: "center",
        alignItems: "baseline"
      }, doubleButtonStyle.buttonActions]}>
      <Grid
        sx={doubleButtonStyle.buttonContainer}
        size={{
          xs: 12,
          sm: 6
        }}>
        {backButton()}
      </Grid>
      <Grid
        sx={doubleButtonStyle.buttonContainer}
        size={{
          xs: 12,
          sm: 6
        }}>
        <Button fullWidth color="primary" variant="contained" onClick={buttonClick} component={Link} to={buttonLink}>
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};

export default DoubleButton;
